// =============================================================================
// FILE:
// frontend/src/ipe/pms/components/site_store_dashboard/SiteStoreInventoryGrid.jsx
// =============================================================================

import React from "react";

import styles
  from "./siteStoreDashboardStyles";


// =============================================================================
// COMPONENT
// =============================================================================

export default function SiteStoreInventoryGrid({

  rows,

  pagination,

  onRowClick

}) {

  // ===========================================================================
  // STATUS BADGE
  // ===========================================================================

  const renderStatusBadge =
    (status) => {

      let style =
        styles.statusHealthy;

      if (status === "LOW") {

        style =
          styles.statusLow;
      }

      if (status === "CRITICAL") {

        style =
          styles.statusCritical;
      }

      return (

        <span style={style}>

          {status}

        </span>
      );
    };


  // ===========================================================================
  // RENDER
  // ===========================================================================

  return (

    <div style={styles.gridCard}>


      {/* ================================================================ */}
      {/* GRID HEADER */}
      {/* ================================================================ */}

      <div style={styles.gridHeader}>


        <div style={styles.gridTitle}>

          Material Inventory

        </div>


        <div style={styles.gridCount}>

          Total Records:
          {" "}
          {pagination.total_records || 0}

        </div>

      </div>


      {/* ================================================================ */}
      {/* TABLE */}
      {/* ================================================================ */}

      <div style={styles.tableWrap}>


        <table style={styles.table}>


          {/* ============================================================ */}
          {/* TABLE HEADER */}
          {/* ============================================================ */}

          <thead style={styles.thead}>


            <tr style={styles.theadRow}>


              <th style={styles.th}>
                Material
              </th>

              <th style={styles.th}>
                Project
              </th>

              <th style={styles.th}>
                Phase
              </th>

              <th style={styles.th}>
                Task
              </th>

              <th style={styles.thRight}>
                Stock
              </th>

              <th style={styles.thRight}>
                Issued
              </th>

              <th style={styles.thRight}>
                Consumed
                </th>

                <th style={styles.thRight}>
                Returned
                </th>

                <th style={styles.thRight}>
                Scrapped
                </th>

                <th style={styles.thRight}>
                Execution Balance
                </th>

                <th style={styles.thRight}>
                Efficiency %
                </th>

              <th style={styles.thCenter}>
                Status
              </th>

            </tr>

          </thead>


          {/* ============================================================ */}
          {/* TABLE BODY */}
          {/* ============================================================ */}

          <tbody>


            {
              rows.length === 0 && (

                <tr>

                  <td
                    colSpan={12}
                    style={styles.emptyTd}
                  >

                    No records found

                  </td>

                </tr>
              )
            }


            {
              rows.map((row, index) => (

                <tr
                  key={index}
                  style={styles.tr}

                  onClick={() => {

                    if (onRowClick) {

                      onRowClick(row);
                    }
                  }}

                  onMouseEnter={(e) => {

                    e.currentTarget.style.background =
                      "#f8fafc";
                  }}

                  onMouseLeave={(e) => {

                    e.currentTarget.style.background =
                      "#ffffff";
                  }}
                >


                  {/* ==================================================== */}
                  {/* MATERIAL */}
                  {/* ==================================================== */}

                  <td style={styles.td}>


                    <div style={styles.materialName}>

                      {row.material_name}

                    </div>


                    <div style={styles.materialCode}>

                      {row.material_code}

                    </div>


                    <div style={styles.materialMeta}>

                      {row.category || "GENERAL"}
                      {" • "}
                      {row.uom || "-"}

                    </div>

                  </td>


                  {/* ==================================================== */}
                  {/* PROJECT */}
                  {/* ==================================================== */}

                  <td style={styles.td}>

                    {row.project_name || "-"}

                  </td>


                  {/* ==================================================== */}
                  {/* PHASE */}
                  {/* ==================================================== */}

                  <td style={styles.td}>

                    {row.phase_name || "-"}

                  </td>


                  {/* ==================================================== */}
                  {/* TASK */}
                  {/* ==================================================== */}

                  <td style={styles.td}>

                    {row.task_name || "-"}

                  </td>


                  {/* ==================================================== */}
                  {/* STOCK */}
                  {/* ==================================================== */}

                  <td style={styles.stockCell}>

                    {row.current_stock_qty || 0}

                  </td>


                  {/* ==================================================== */}
                  {/* ISSUED */}
                  {/* ==================================================== */}

                  <td style={styles.issuedCell}>

                    {row.issued_qty || 0}

                  </td>


                  {/* CONSUMED */}

                    <td style={styles.consumedCell}>

                    {row.consumed_qty || 0}

                    </td>


                    {/* RETURNED */}

                    <td
                    style={{
                        ...styles.tdRight,
                        color: "#16a34a",
                        fontWeight: 700
                    }}
                    >

                    {row.returned_qty || 0}

                    </td>


                    {/* SCRAPPED */}

                    <td
                    style={{
                        ...styles.tdRight,
                        color: "#dc2626",
                        fontWeight: 700
                    }}
                    >

                    {row.scrap_qty || 0}

                    </td>


                    {/* EXECUTION BALANCE */}

                    <td style={styles.pendingCell}>

                    {row.pending_consumption_qty || 0}

                    </td>


                    {/* EFFICIENCY */}

                    <td
                    style={{
                        ...styles.tdRight,
                        color: "#2563eb",
                        fontWeight: 700
                    }}
                    >

                    {row.consumption_efficiency_percent || 0}%

                    </td>

                  {/* ==================================================== */}
                  {/* STATUS */}
                  {/* ==================================================== */}

                  <td style={styles.tdCenter}>

                    {
                      renderStatusBadge(
                        row.stock_status
                      )
                    }

                  </td>

                </tr>
              ))
            }

          </tbody>

        </table>

      </div>

    </div>
  );
}